import { useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, Box, Paper } from "@material-ui/core";
import { selectUserFullName } from "redux/auth/selectors";
import View from "components/utils/View";
import SrCurrency from "components/common/SrCurrency";
import useDashboard from "./useDashboard";
import ComissionDialog from "./ComissionDialog";
import Deposits from "./Deposits";
import {
  DateRange,
  SrCard,
  Typography,
  SrContentWrapper,
  SrContentHeader,
} from "../../../common";
import translate from "../../../../i18n/translate";
import { TransactionsTable } from "../../../TransactionsTable";

const Resume = () => {
  const intl = useIntl();
  const { user } = useSelector(({ auth }) => auth);
  const userFullName = useSelector(({ auth }) => selectUserFullName(auth));
  const [range, setRange] = useState();
  const {
    loading,
    error,
    transactions,
    deposits,
    dashboard: { transaction = 0, totalProcessed = 0 },
  } = useDashboard(range, user.username);
  const [isOpen, setIsOpen] = useState(false);

  const title = `${intl.formatMessage({
    id: "resume.greetings.title",
  })} ${userFullName}`;

  return (
    <View translateTitleKey="menu.resume">
      <Grid container item direction="column" spacing={3}>
        <SrContentHeader
          title={title}
          subTitle={translate("resume.greetings.whatIsHappeningInBusiness")}
          actions={
            <DateRange
              onDateSelected={({ startDate, endDate }) => {
                setRange({ startDate, endDate });
              }}
              actionButtons
            />
          }
        />
        <SrContentWrapper isLoading={loading}>
          {error ? (
            <Grid container justifyContent="center" spacing={2}>
              <Box padding={4}>
                <Typography variant="h3">
                  <FormattedMessage id="resume.error.title" />
                </Typography>
              </Box>
            </Grid>
          ) : (
            <>
              <Grid container item spacing={2}>
                <Grid item xs={12} sm>
                  <SrCard
                    title={translate("resume.cards.transactions")}
                    titleId="transactionsCard"
                    value={transaction}
                  />
                </Grid>
                <Grid item xs={12} sm>
                  <SrCard
                    title={translate("resume.cards.totalProcessed")}
                    titleId="totalProcessedCard"
                    value={<SrCurrency value={totalProcessed} />}
                    onIconClick={() => setIsOpen(true)}
                  />
                  <ComissionDialog
                    isOpen={isOpen}
                    onClose={() => {
                      setIsOpen(false);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Paper
                    component="section"
                    aria-labelledby="latest-transactions"
                    elevation={0}
                  >
                    <Box padding={4}>
                      <Typography variant="h3" id="latest-transactions">
                        {translate("resume.latestTansactions")}
                      </Typography>
                    </Box>
                    <TransactionsTable
                      transactions={transactions}
                      loading={loading}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper
                    component="section"
                    aria-labelledby="latest-deposits"
                    elevation={0}
                  >
                    <Box padding={4}>
                      <Typography variant="h3" id="latest-deposits">
                        {intl.formatMessage({ id: "resume.latestWithdrawals" })}
                      </Typography>
                    </Box>
                    <Deposits deposits={deposits} loading={loading} />
                  </Paper>
                </Grid>
              </Grid>
            </>
          )}
        </SrContentWrapper>
      </Grid>
    </View>
  );
};

export default Resume;
